<template>
  <lDfault title="快速注册">
    <mcode
      @imgCodePassed="imgCodePassed"
      @click="codeUpdate"
      :valiImg="imgCode"
      :show="showCode"
    ></mcode>
    <!-- <toast text='该手机号已经注册过了，请换一个手机号'></toast> -->
    <main class="sign-up">
      <div v-if="registerSwitchReady && !registerEnabled" class="reg-disabled-notice">
        <van-icon name="info-o" size="48" color="#ff976a" />
        <p class="notice-title">注册功能暂时关闭</p>
        <p class="notice-desc">{{ registerDisabledMsg }}</p>
      </div>
      <template v-else-if="registerSwitchReady && registerEnabled">
      <h3>用手机号注册</h3>
      <van-field v-model="phone" label="手机号" placeholder="请输入手机号" />

      <van-button
        :disabled="!isOk"
        class="submit"
        type="primary"
        @click="onSubmit"
        block
        >立即注册</van-button
      >
      </template>

      <div class="forget-sign">
        <router-link to="Login">已有账号，快速登录</router-link>
      </div>
    </main>
  </lDfault>
</template>

<script>
import validator from "validator";
// @ is an alias to /src
import mcode from "./children/Code";
import { isRegister,getImgCode } from "@/api";
import lDfault from "@/templates/Default.vue";
import behaviorTracker from "@/mixins/behaviorTracker";
import registerSwitch from "@/mixins/registerSwitch";
import * as bt from "@/utils/behaviorTracker";
// import toast from "@/components/Toast.vue";
// import icon from "@/components/Icon.vue";
export default {
  mixins: [behaviorTracker, registerSwitch],
  __behaviorStep: "signup_phone",
  components: {
    lDfault,mcode
    // icon,
  },
  data() {
    return {
      phone: "",
      isOk: false,
      imgCode: {},
      showCode: false,
    };
  },
  watch: {
    phone(nv) {
      this.isOk = nv.length ? true : false;
    },
  },
  created() {
    // 页面创建时读取地址栏的bsc参数并保存到localStorage
    this.getBscFromUrl();
    bt.startFlow();
  },
  methods: {
    // 获取URL中的bsc参数并保存到localStorage
    getBscFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const bscValue = urlParams.get('bsc');
      if (bscValue) {
        localStorage.setItem('bsc', bscValue);
      }
    },
    imgCodePassed(code) {
   sessionStorage.setItem('verify',JSON.stringify({
          way:'signup',
          phone: this.phone,
          getCode: 'getRegisterCode',
          handler: 'loginPhone',
          imgCodeValue: code,
          nextStation:{name:"ModifyPasswd",params:{phone:this.phone}},
           textGroup: {
            title: "校验验证码",
            subTitle: "",
            placeholder: "请输入验证码",
            button: "校验",
          },
        },))


      // rqGetFindpwdCode({ phone: this.phone, veriValidCode: code });
      this.$router.push({
        name: "VerifyCode",
      });
    },
    codeUpdate() {
      this.showCode = false;
    },
    refreshCode() {
      getImgCode().then((res) => {
        this.imgCode = res;
      });
    },
    passedCode(isOk) {
      console.log(isOk);
      this.isOk = isOk;
    },
    onSubmit() {
      if (!validator.isMobilePhone(this.phone, "zh-CN")) {
        this.$toast("请检查你的手机号");
        return;
      }
      isRegister({ phone: this.phone }).then((res) => {
        if (res) {
          // 该手机已经被注册，请更换其它手机
          this.$toast("该手机已经被注册，请更换其它手机");
        } else {
          // go to 注册
           this.showCode=true
           this.refreshCode()
          // getCode({ phone: this.phone }).then((res) => {
          //   console.log(res);
          // });
          // this.$router.push("signup2/" + this.phone);
          // this.$router.push("signup2/" + this.phone);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sign-up {
  padding: 0 30px;
  .submit {
    margin-top: 20px;
  }
  .reg-disabled-notice {
    text-align: center;
    padding: 60px 20px;
    .notice-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin: 16px 0 8px;
    }
    .notice-desc {
      font-size: 14px;
      color: #999;
      line-height: 1.6;
    }
  }
}
.forget-sign {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  a {
    color: #07c160;
  }
}
</style>
